// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"196":"936404fc","605":"317ba660","840":"926c1da3","920":"ca2764b1","962":"7cb6f376"}[chunkId] + ".chunk.css";
};